export const setUrls = (appUrl) => {
  const baseUrl = getUrls(appUrl)
  const eonUrl = getEonUrlFromConfig(appUrl)
  localStorage.setItem('baseUrl', JSON.stringify(baseUrl))
  localStorage.setItem('eonUrl', JSON.stringify(eonUrl))
}
const getUrls = (appUrl) => {
  if (appUrl === 'epg.nova.gr') {
    return process.env.DEFAULT_URLS.domainsGR
  } else {
    return process.env.DEFAULT_URLS.domains
  }
}
export const getEonUrlFromConfig = () => {
  return process.env.EON_URL
}
export const getBaseUrls = (type) => {
  const baseApi = JSON.parse(localStorage.getItem('baseUrl'))
  return baseApi ? baseApi[type] : process.env.DEFAULT_URLS.domains
}
export const getEonUrl = () => {
  const eonLink = JSON.parse(localStorage.getItem('eonUrl'))
  return eonLink || process.env.EON_URL
}



// WEBPACK FOOTER //
// ./src/helpers/baseURLhelper.js